import SectionHeader from 'components/SectionHeader';
// import branch from 'branch-sdk';
import moment from 'moment-timezone';
import React, { useEffect, useState } from "react";
import { getOfferingCheckout } from 'util/api/CheckoutAPI'
import { useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import { useRouter } from 'util/router'
import analytics from "util/analytics";
import { db, firebase, useAuth } from 'util/auth';
import ShareButton from 'components/ShareButton'

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function OfferingConfirmation(props) {

    // const location = useLocation()
    const router = useRouter()
    const widgetName = useSelector(state => state.widget?.instructor?.widgetName)
    const auth = useAuth();
    const offeringId = props.match.params.platformID
    var selectedOffering = useSelector(state => state.widget.offerings?.find(val => val.id === offeringId));
    const [apiOffering, setApiOffering] = React.useState(null)
    if (apiOffering) {
        selectedOffering = apiOffering
    }

    useEffect(() => {
        // setIsLoading(true)
        getOfferingCheckout(offeringId, null)
            .then(data => {
                if (data.offering) {
                    setApiOffering(data.offering)
                }
            })
            .catch(err => {
                // setIsLoading(false)
                // if (err.message)
                console.log("Error fetching checkout: ", err)
            })
    }, [])
    // const selectedOffering = useSelector(state => state.widget.classes.find(val => val.platformID == classID));

    function openAppStore() {
        analytics.track('Open App Clicked')
        window.open('https://sutrafitness.app.link')
    }

    const [reservation, setReservation] = useState(null);

    let reservation_id = useQuery().get('reservation_id');
    let session_id = useQuery().get('session_id');

    // useEffect(() => { TODO
    //     analytics.page({classID: classID})
    //     // console.log(classID)
    // }, [classID])

    useEffect(() => {
        if (reservation) {
            analytics.track("Post Purchase Viewed", reservation);
        }
    }, [reservation])
    
    useEffect( () => {
        async function fetchReservation() {
            if (reservation_id) {
                try {
                    console.log("Fetching reservation")
                    const doc = await db.collection("reservations").doc(reservation_id).get();
                    if (doc.exists) {
                        var res = doc.data();
                        res.platformID = doc.id;
                        setReservation(res);
                    }
                } catch (err) {
                    window.alert("Couldn't fetch reservation: " + err)
                    // console.log("Couldn't fetch reservation: " + err)
                }
            } else if (session_id) {
                try {
                    const doc = await db.collection("reservations").doc(session_id).get();
                    if (doc.exists) {
                        var res = doc.data();
                        res.platformID = doc.id;
                        setReservation(res);
                    }
                } catch (err) {
                    window.alert("Couldn't fetch reservation: " + err)
                }
            }
        }

        function loadReservations() {
            setTimeout(function() {
                fetchReservation()
            }, 2000)
            setTimeout(function() {
                if (!reservation) {
                    fetchReservation()
                }
            }, 5000)

        }
        loadReservations()
    }, [reservation_id, session_id]);

    useEffect( () => {
        if (reservation) {
            var obj = {}
            if (reservation.objectSnapshot) {
                obj = reservation.objectSnapshot
            } else {
                obj.instructor_name = reservation.instructor_name ?? "unknown";
                obj.instructor_id = reservation.instructor_id ?? "unknown"
            }
            obj.insert_id = reservation_id;
            console.log("success")
            console.log(obj)
            // analytics.track("bookingSuccess", obj)
        }

    }, [reservation]);

    // function handleOpenSutraApp(e) {
    //     analytics.track("Open App Clicked")
    //     window.branch.link({
    //         tags: ['class'],
    //         channel: 'website',
    //         feature: 'widget',
    //         data: {
    //             shareType: "class",
    //             // platformID: classID
    //         }
    //     }, function(err, link) {
    //         if (link && window.location) {
    //             window.location.assign(link);
    //             // window.open(link);
    //         }
    //     });
    // }

    const [message, setMessage] = useState("")
    const [messageSent, setMessageSent] = useState(false);
    async function handleSendMessage(e) {
        e.preventDefault()
        if (message.length <= 3) {
            window.alert("Please send a longer message")
            return
        }
        
        if (!auth.userData) {

            window.alert("You must be logged in")
            return
            
        }

        
        
        const new_message = {
            fromUserId: auth.userData.platformID,
            fromUserName: auth.userData.firstName,
            toUserId: selectedOffering.instructor_id,
            toUserName: selectedOffering.instructor_name,
            text: message,
            isViewed: false,
            createdAt: firebase.firestore.Timestamp.now()
        }

        const message_id = `${new_message.fromUserId}-${new_message.toUserId}-${new_message.createdAt}`

        try {
            await db.collection("messages").doc(message_id).set(new_message, {merge: true})
            setMessageSent(true);
            analytics.track('Send Private Message')
        } catch (err) {
            analytics.track('Send Private Message Failed')
            window.alert(err)
        }
        

        
    }
    function handleMessageChange(e) {
        setMessage(e.target.value)
    }

    const [confirmationEmail, setConfirmationEmail] = useState("")
    const [confirmationEmailSent, setConfirmationEmailSent] = useState(false)
    async function handleConfirmationEmailSubmit(e) {
        e.preventDefault()
        analytics.track('Send Confirmation Email')
        await sendConfirmEmail(confirmationEmail);
        setConfirmationEmailSent(true)
    }
    function handleConfirmationEmailChange(e) {
        setConfirmationEmail(e.target.value)
    }

    async function sendConfirmEmail(email) {
        var data = {
            email: email,
            reservation_id: reservation_id ? reservation_id : (session_id ? session_id : "unknown")
        }
        const functions = firebase.functions();
        const sendConfirmationEmail = functions.httpsCallable("sendConfirmationEmail");
        try {
            const response = await sendConfirmationEmail(data)
        } catch (err) {
            console.log(err)
            window.alert(`Failed to send confirmation email: ${err}`)   
        }
    }

    moment.locale('en', {
        calendar : {
            lastDay : '[Yesterday]',
            sameDay : '[Today]',
            nextDay : '[Tomorrow]',
            lastWeek : '[last] dddd [at] LT',
            nextWeek : 'dddd [at] LT',
            sameElse : 'dddd MMM Do'
        }
    });

    var viewModel = {}
    console.log("BOOKING CANCEL: ")
    if (selectedOffering) {
        viewModel = {
            name: selectedOffering.name ?? selectedOffering.class_name,
            timeString: moment(selectedOffering.start_time * 1000).format("ddd MMM Do • h:mma - ") + moment((selectedOffering.start_time + (selectedOffering.duration * 60)) * 1000).format("h:mma") + ` ${moment.tz(moment.tz.guess()).format('z')}`,
            instructorName: selectedOffering.instructor_name,
            image: (selectedOffering.images && selectedOffering.images.length > 0) ? selectedOffering.images[0] : "",
            shareLink: (process.env.REACT_APP_BOOKING_CANCEL_URL) + props.match.url.replace("confirm", "checkout"),
            location: selectedOffering.location?.cityState ?? "LIVESTREAM",
        }
    }

    console.log("VIEW MODEL: ", viewModel)
    console.log(process.env.REACT_APP_BOOKING_CANCEL_URL)
    console.log(props.match.url.replace("confirm", "checkout"))

    /* found reservation (probably by reservation_id -- they probably booked it for free... send them a confirmation email!) */
    // const showSendConfirmationEmail =  reservation && reservation.existingUser === false && !reservation.customer_email;
    // const showSendConfirmationEmail = true;

    /* User doesn't have an account, and entered their email during checkout...
        Let's ask them to create an account! */
    const showCreateAccount = reservation && reservation.existingUser === false ;
    // && reservation.customer_email;

    /* User entered email during stripe checkout and we detected they already have an account
        Let's prompt them to open up the app to see the reservation ! */
    const showOpenSutraApp = reservation && reservation.existingUser && reservation.customer_email;

    const subtitle = (reservation && reservation.customer_email) ? `We’ve sent a confirmation to ${reservation.customer_email}` : "";

    if (reservation) {
        console.log("found the reservation: ", reservation)
    }

    let height;
    const sendPostMessage = () => {
        let conatinerId = "fullWidthWidget"
        if (document.getElementById(conatinerId)) {
            if (height !== document.getElementById(conatinerId).offsetHeight) {
                height = document.getElementById(conatinerId).offsetHeight;
                window.parent.postMessage({
                  frameHeight: height
                }, '*');
                // console.log(height);
              }
        }
        
    }
    useEffect(() => {
        sendPostMessage()
    })
    return (
        
        <div
        className="mb-0 mt-4 mx-0"
        >
            <SectionHeader
            title="Confirmed!"
            // subtitle={subtitle}
            className="text-center"
             />

            
            <div className="mt-4 d-flex d-row align-items-center">
                <button
                className="btn btn-link primaryColor m-auto"
                onClick={() => {
                    router.replace("/" + widgetName)
                }}>
                    Book a class
                </button>
                {/* <ShareButton
                className="m-auto"
                buttonText="Invite friends to join!"
                link={viewModel.shareLink}
                /> */}
            </div>

            {true && (
                <div className="text-center">
                    {/* <h6>We've sent an email&nbsp;{reservation.customer_email ? `to ${reservation.customer_email}` : ""}</h6> */}
                    
                    <div className="mt-4 d-flex d-row align-items-center">

                        <ShareButton
                        className="m-auto"
                        buttonText="Invite friends to join!"
                        link={viewModel.shareLink}
                        />
                    </div>
                </div>
            )}
            <hr className="mt-5" />
        </div>
    );
}

export default OfferingConfirmation;
